import React from 'react';
import { debounce } from 'lodash';
import smoothscroll from 'smoothscroll-polyfill';
import ScrollTopIcon from '../../../../svg/icons/scroll-top.svg';
import scrollToTopStyles from './scrollToTop.module.pcss';

smoothscroll.polyfill();

interface ScrollToTop {
  show?: boolean;
}

interface WindowVee24 extends Window {
  vee24?: {
    events?: {
      tabOpened?: any;
      tabClosed?: any;
    };
  };
}

let isBtnClicked = false;
let isWheelMoving = false;

function ScrollToTop({ show = false }: ScrollToTop): React.ReactElement | null {
  const [showScroll, setShowScroll] = React.useState(show);
  const windowVee24: WindowVee24 = window;

  const onScroll = debounce(() => {
    if (window.pageYOffset > window.innerHeight) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
  }, 100);

  function mouseWheelHandler(): void {
    isWheelMoving = true;

    if (isWheelMoving && isBtnClicked) {
      const x = window.scrollX;
      const y = window.scrollY - 1; // 1 is added to fix bounce back on stop
      window.scrollTo(x, y);

      cleanUpEvents();
    }
  }

  function cleanUpEvents(): void {
    isBtnClicked = false;
    isWheelMoving = false;
    window.removeEventListener('wheel', mouseWheelHandler);
  }

  function onClick(): void {
    setShowScroll(false);

    isBtnClicked = true;

    if (isBtnClicked) {
      window.addEventListener('wheel', mouseWheelHandler, false);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  React.useEffect(() => {
    let limit = 15;

    const interval = setInterval(() => {
      limit -= 1;

      if (windowVee24?.vee24?.events?.tabOpened && windowVee24?.vee24?.events?.tabClosed) {
        const originalTabOpened = windowVee24.vee24.events.tabOpened;
        const originalTabClosed = windowVee24.vee24.events.tabClosed;

        windowVee24.vee24.events.tabOpened = (): void => {
          setShowScroll(false);
          originalTabOpened();
        };

        windowVee24.vee24.events.tabClosed = (): void => {
          setShowScroll(true);
          originalTabClosed();
        };

        clearInterval(interval);
      } else if (limit === 0) {
        clearInterval(interval);
      }
    }, 1000);
  }, []);

  React.useEffect(() => {
    window.addEventListener('scroll', onScroll);

    onScroll();

    return (): void => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('wheel', mouseWheelHandler);
    };
  }, []);

  return showScroll ? (
    <button className={scrollToTopStyles['scroll-to-top']} onClick={onClick} title="Scroll to top" type="button">
      <ScrollTopIcon className={scrollToTopStyles['scroll-to-top__icon']} />
    </button>
  ) : null;
}

export default ScrollToTop;
